function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.76 0a.51.51 0 00-.55.44l-1 9a.5.5 0 00.44.55h.05a.5.5 0 00.5-.44l1-9A.5.5 0 003.76 0zM1.767 0H1.76a.51.51 0 00-.55.44l-1 9a.5.5 0 00.433.56H.7a.5.5 0 00.5-.44l1-9A.5.5 0 001.767 0zM15 9.5a5.5 5.5 0 105.5 5.5A5.507 5.507 0 0015 9.5zm2 6h-2a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v2.5H17a.5.5 0 010 1z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.49 9.98A8.957 8.957 0 0010.93 7L10.2.44a.502.502 0 00-1-.09L7.7 5.19 6.18.35a.502.502 0 00-1 .09l-1 9a.503.503 0 001 .11l.74-6.64L7.23 7a.5.5 0 001 0l1.29-4.1.48 4.63a9 9 0 1012.49 2.45zM15 21.5a6.5 6.5 0 116.5-6.5 6.508 6.508 0 01-6.5 6.5z"
});

function SvgMdDelay(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "mdDelay.2456f.svg";
export { SvgMdDelay as ReactComponent };